﻿unspecified = 'Unspecified'

Vue.component 'filter-select',
    template: """
<div>
    <label><slot></slot></label>
    <select v-model="val" class="form-control">
        <option value="#{unspecified}">#{unspecified}</option>
        <option v-for="count, name in sortedList"
                :value="name">{{name}} ({{count}})</option>
    </select>
</div>
"""
    props: ['value', 'list']

    computed:
        val:
            get: -> @value
            set: (val)-> @$emit 'input', val

        sortedList: ->
            sorted = {}
            for k in Object.keys(@list).sort()
                sorted[k] = @list[k]
            sorted

searchMixin = (memberList, fields)->
    data = {} # default data fields
    data[f] = unspecified for f in fields

    comps  = {} # default dropdown filter lists
    makeFn = (field)-> -> @filterDropdown field
    for f in fields
        comps["#{f}_list"] = makeFn f

    comps.allUnspecified = -> # check if all filters unset
        return false for f in fields when @[f] isnt unspecified
        true

    comps.empty = -> @filteredList.length is 0
        
    el: '#search-app'
    data:     data
    computed: comps

    methods:
        ## check if a member has a value in an array property
        ## that matches one selected in any of the search filters
        checkFields: (member, skipField)->
            for f in fields when f isnt skipField
                val = @[f]
                continue if val is unspecified
                return false if val not in member[f]
            true

        ## shortlist filter dropdowns with the number of members
        ## that each value has, only those > 0 are kept in list
        filterDropdown: (dataField)->
            list    = {}
            for m in memberList
                continue if not @checkFields m, dataField
                for el in m[dataField]
                    if el not of list
                        list[el] = 0
                    list[el]++
            list

        defaultList: (def)-> # value to return when filters are clear
            return def if @allUnspecified
            memberList.filter @checkFields

        resetFilters: -> @[f] = unspecified for f in fields

## memberList is a list of entities to display
## fields is a list categories to filter the member list by
@membersApp = (memberList, fields)-> new Vue
    mixins: [searchMixin(memberList, fields)]
    computed:
        filteredList: -> @defaultList []

## memberList is a list of entities to display
## fields is a list categories to filter the member list by
@speakersApp = (memberList, fields)-> new Vue
    mixins: [searchMixin(memberList, fields)]
    computed:
        filteredList: -> @defaultList memberList

    methods:
        trim: (text, charNum = 100)->
            return text if text.length <= charNum
            spaceAt = 0
            for i in [0...charNum]
                spaceAt = i if text.at(i) is ' '
            (text.slice 0, spaceAt) + "..."
